import { flexRender } from '@tanstack/react-table';

const Table = ({ table, loading }) => {
    if (loading) {
        return (
            <div className="animate-pulse fade-in">
                {/* Single placeholder block approximating table size */}
                <div className="w-full h-[4000px] bg-gray-200 rounded"></div>
            </div>
        );
    }

    return (
        <div className="table-wrapper fade-in">
            <table className="w-full transition-opacity duration-150 border border-collapse">
                <thead>
                    {table.getHeaderGroups().map(headerGroup => (
                        <tr key={headerGroup.id}>
                            {headerGroup.headers.map(header => (
                                <th key={header.id} className="p-2 capitalize border">
                                    {flexRender(
                                        header.column.columnDef.header,
                                        header.getContext()
                                    )}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody>
                    {table.getRowModel().rows.map(row => (
                        <tr key={row.id}>
                            {row.getVisibleCells().map(cell => (
                                <td key={cell.id} className="p-2 border">
                                    {flexRender(
                                        cell.column.columnDef.cell,
                                        cell.getContext()
                                    )}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default Table;